export const authHeaders = () => ({ headers: {} });
